// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"50e7dfe0","453":"ececc0a5","596":"7152eb4b","638":"d0b85ea1","965":"30405e8d","989":"3473bc8b"}[chunkId] + ".chunk.js";
};